import { useAccounts, useSettings } from '../../contexts';

import { ModalIds } from '../../../../contexts/modals/modals.types';
import { useCallback } from 'react';
import { useModalsContext } from '../../../../contexts';
import { useQueryParams } from '../../shared';
import { useTranslation } from 'react-i18next';

const useHeaderHook = () => {
  const [state, setState] = useSettings();
  const { t } = useTranslation('translation', { keyPrefix: 'management.reports.common.header' });
  const { dispatch: modalsDispatch } = useModalsContext();
  const { currentAccount } = useAccounts();
  const { parsed } = useQueryParams();

  const handlePrint = () => {
    if (typeof window === 'undefined') return;

    const wasExpanded = state.expanded;
    setState((prev) => ({ ...prev, expanded: true }));

    setTimeout(() => {
      window.print();
      if (!wasExpanded) {
        setState((prev) => ({ ...prev, expanded: false }));
      }
    }, 300);
  };

  const handleGenerateModalOpen = useCallback(() => {
    if (currentAccount) {
      modalsDispatch({
        type: 'SHOW_MODAL',
        payload: {
          id: ModalIds.reportsGenerateReport,
          data: {
            reportsGenerateReport: {
              clientEmailOwner: !parsed?.ownership ? currentAccount.ClientEmailOwner : parsed?.email,
            },
          },
        },
      });
    }
  }, [currentAccount, modalsDispatch, parsed?.email, parsed?.ownership]);

  return { t, state, handlePrint, handleGenerateModalOpen };
};

export { useHeaderHook };
